





















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Chapter extends Vue {
    @Prop()
    private libraryId !: number;

    private loading = false;

    private pagedData = [];

    created() {
        this.reload();
    }

    reload() {
        this.$apis.getChapters(this.libraryId)
            .then((res: any) => {
                this.pagedData = res.data;
            });
    }

    // 布尔值格式化：cellValue为后台返回的值
    formatBoolean(row: any, column: any, cellValue: boolean) {
        let ret = ''  //你想在页面展示的值
        if (cellValue) {
            ret = "是"  //根据自己的需求设定
        } else {
            ret = "否"
        }
        return ret;
    }

    onTopic(id: string) {
        this.$router.push({ path: "/test/browse", query: { libraryId: this.libraryId.toString(), chapterId: id } });
    }

    onTest(id: string) {
        sessionStorage.removeItem("topics");
        this.$router.push({ path: "/test/practice", query: { libraryId: this.libraryId.toString(), chapterId: id } });
    }

    onMock(id: string) {
        sessionStorage.removeItem("topics");
        this.$router.push({ path: "/test/mock", query: { libraryId: this.libraryId.toString(), chapterId: id } });
    }
}
